import React from 'react';
import {connect} from 'react-redux';
import BillboardSidebarBase from './BillboardSidebarBase';
import UserAreaNav from '../UserAreaNav';
import {getCinemasByArea,getCinemasByState,getBootstrapFilters} from '../../reducers';
import LinkButton from '../LinkButton';

class BillboardSidebar extends React.Component {
  render() {
    return <BillboardSidebarBase
        heading={<UserAreaNav
          area={this.props.area}
          areaSelector={<LinkButton onClick={this.props.onAreaChangeClick} icon='fa-angle-down'>
            {this.props.area ? this.props.area.name : 'Selecciona una zona'}
          </LinkButton>}
        />}
        cinemas={this.props.cinemas}
        baseUrl={this.props.baseUrl}
        {...this.props}
    />;
  }
}

const mapStateToProps = (state, props) => {
  const {urlParams, areaId, area, isState} = props;

  const attributes = getBootstrapFilters(state);

  return {
    area,
    attributes,
    cinemas: isState ? getCinemasByState(state, areaId) : getCinemasByArea(state, areaId),
    urlParams,
  };
};

const uniqueMovies = movies => {
  const result = [];
  const ids = [];

  movies.forEach(movie => {
    if (ids.indexOf(movie.id) < 0) {
      result.push(movie);
      ids.push(movie.id);
    }
  });

  return result;
};

export default connect(
    mapStateToProps
)(BillboardSidebar);